/**
 * Sahyog Finance & Noble Infinity brand emblem.
 * Single high-res source used across all sites + dashboard.
 */
export default function Logo({ size = 44, className = "", testId = "brand-logo" }) {
  return (
    <span
      data-testid={testId}
      className={`relative inline-block shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <span
        className="absolute inset-0 rounded-full"
        style={{
          background:
            "radial-gradient(circle at 30% 30%, rgba(255,228,140,0.35), rgba(180,140,30,0.15) 60%, transparent 75%)",
        }}
      />
      <img
        src="/sahyog-logo-512.webp"
        srcSet="/sahyog-logo-256.webp 256w, /sahyog-logo-512.webp 512w"
        sizes={`${size}px`}
        width={size}
        height={size}
        loading="lazy"
        decoding="async"
        alt="Sahyog Finance & Noble Infinity Asset Management Pvt Ltd"
        className="relative w-full h-full object-contain drop-shadow-[0_6px_24px_rgba(212,175,55,0.45)]"
      />
    </span>
  );
}
